var App = App || {};

App.CookieNotice = (() => {
    'use strict';

    let notice;

    const init = () => {
        notice = document.getElementById('cookie-notice');
        notice.querySelector('.cookie-notice__dismiss')
            .addEventListener('click', dismiss);
    }

    const dismiss = e => {
        notice.classList.add('cookie-notice--dismissed');
        notice.addEventListener('transitionend', afterDismissed);
        App.Cookies.setItem('CookieNoticeConfirmed', 'true', Infinity, '/', window.location.hostname, window.location.protocol === 'https:');
    }

    const afterDismissed = () => {
        notice.remove();
    }

    return {
        init: init
    };
})();